import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_EMPLOYEE_CATEGORY_TAGS,
  GET_EMPLOYEE_CATEGORY_TAGS,
  SG_FETCH_EMPLOYEE_CATEGORY_TAG,
  FETCH_EMPLOYEE_CATEGORY_TAG,
  SG_ADD_EMPLOYEE_CATEGORY_TAG,
  ADD_EMPLOYEE_CATEGORY_TAG,
  SG_UPDATE_EMPLOYEE_CATEGORY_TAG,
  UPDATE_EMPLOYEE_CATEGORY_TAG,
  SG_DELETE_EMPLOYEE_CATEGORY_TAG,
  DELETE_EMPLOYEE_CATEGORY_TAG,
  EMPLOYEE_CATEGORY_TAGS_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getEmployeeCategoryTags(action) {
  try {
    yield put({ type: EMPLOYEE_CATEGORY_TAGS_PENDING });
    const response = yield call(api.GET_EMPLOYEE_CATEGORY_TAGS, action.payload);
    yield put({ type: GET_EMPLOYEE_CATEGORY_TAGS, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchEmployeeCategoryTag(action) {
  try {
    yield put({ type: EMPLOYEE_CATEGORY_TAGS_PENDING });
    const response = yield call(api.FETCH_EMPLOYEE_CATEGORY_TAG, action.payload);
    yield put({ type: FETCH_EMPLOYEE_CATEGORY_TAG, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addEmployeeCategoryTag(action) {
  try {
    yield put({ type: EMPLOYEE_CATEGORY_TAGS_PENDING });
    const response = yield call(api.ADD_EMPLOYEE_CATEGORY_TAG, action.payload);
    yield put({ type: ADD_EMPLOYEE_CATEGORY_TAG, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateEmployeeCategoryTag(action) {
  try {
    yield put({ type: EMPLOYEE_CATEGORY_TAGS_PENDING });
    const response = yield call(api.UPDATE_EMPLOYEE_CATEGORY_TAG, action.payload);
    yield put({ type: UPDATE_EMPLOYEE_CATEGORY_TAG, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteEmployeeCategoryTag(action) {
  try {
    yield put({ type: EMPLOYEE_CATEGORY_TAGS_PENDING });
    yield call(api.DELETE_EMPLOYEE_CATEGORY_TAG, action.payload);
    yield put({ type: DELETE_EMPLOYEE_CATEGORY_TAG, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* employeeCategoryTagsSaga() {
  yield takeLatest(SG_GET_EMPLOYEE_CATEGORY_TAGS, getEmployeeCategoryTags);
  yield takeLatest(SG_FETCH_EMPLOYEE_CATEGORY_TAG, fetchEmployeeCategoryTag);
  yield takeLatest(SG_ADD_EMPLOYEE_CATEGORY_TAG, addEmployeeCategoryTag);
  yield takeLatest(SG_UPDATE_EMPLOYEE_CATEGORY_TAG, updateEmployeeCategoryTag);
  yield takeLatest(SG_DELETE_EMPLOYEE_CATEGORY_TAG, deleteEmployeeCategoryTag);
}